import BaseModel from "./BaseModel";

export default class CsrfToken extends BaseModel {
  private _key: string = "";
  private _value: string = "";
  private _code: string = "";
  private _time: number = 0;

  get key (): string {
    return this._key;
  }

  set key (value: string) {
    this._key = value;
  }

  get value (): string {
    return this._value;
  }

  set value (value: string) {
    this._value = value;
  }

  get code (): string {
    return this._code;
  }

  set code (value: string) {
    this._code = value;
  }

  get time (): number {
    return this._time;
  }

  set time (value: number) {
    this._time = value;
  }
}
